/* unplugin-vue-components disabled */import script from "./xListLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./xListLayout.vue?vue&type=script&setup=true&lang=js"

import "./xListLayout.vue?vue&type=style&index=0&id=5ebf5387&lang=less&scoped=true"
import "./xListLayout.vue?vue&type=style&index=1&id=5ebf5387&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ebf5387"]])

export default __exports__